import React from "react";
import Header from "./header";
import Footer from "./footer";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";



function RefundPolicy() {
    return (

        // aboutcompany
        <>
           


            <div className="space80"></div>

            <div className="about-company">
                <div className="space80"></div>
                <div className="hero-area10 ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="title title2  ">

                                    <h1 className="sk-text-color text-center">Refund Policy</h1>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>



                <div className="space50"></div>
                <div className="service-binifits9 sp0" >
                    <div className="container">
                        <div className="row">

                            <div className="col-lg-12">

                                <ul>
                                    <li className="pd-text"><i className="fa fa-circle icone"></i> This Refund Policy is effective for all kinds of purchases made on different channels and platforms of Dm2Legal PRIVATE LIMITED, not limited to our official website (www.Dm2Legal.com), Mobile Applications, Agents, Partners, Super distributors, etc.</li>
                                    <div className="space20"></div>
                                    <li className="pd-text"><i className="fa fa-circle icone"></i> We thank you and value your service or product purchase with Dm2Legal PRIVATE LIMITED. Please read this policy and the Dm2Legal terms and conditions thoroughly as they will give you relevant information and guidelines about your virtues and responsibilities as our customer, concerning any product or service we provide to you.</li>
                                    <div className="space20"></div>
                                    <li className="pd-text"><i className="fa fa-circle icone"></i> We make every endeavor to assist you as per the stipulations and timelines specified against each service or product received by you to Dm2Legal, nevertheless, if, due to any cause, we are incapable of offering to you the service or product you purchased from us, then you shall be entitled to a refund which shall be subjected on the following situations:</li>

                                </ul>
                                <div className="space20"></div>

                                <h2>Refund</h2>
                                <ol>
                                    <li className="pd-text">The case in which the service booked by you is not completed by Dm2Legal or is of such a nature that it can not be completed by Dm2Legal. In such a case refund will be provided.</li>
                                    <div className="space20"></div>
                                    <li className="pd-text">The case wherein a mistake has been made on the part of Dm2Legal. It is pertaining to mention here that, the said mistake should be made by the team of Dm2Legal, any mistake on the part of the customer should not be eligible as a valid ground for a refund. In such case of a mistake refund will be provided.</li>
                                </ol>


                                <div className="space20"></div>

                                <h2>No Refund</h2>
                                <ol>
                                    <li className="pd-text">In the event a customer has paid for a service and then requests a refund only because there was a change of mind, the refund shall not be considered as there is no fault on the part of Dm2Legal. In such a case refund will not be provided.</li>
                                    <div className="space20"></div>
                                    <li className="pd-text">For our consultation and other Advice Services including Legal Advice, no refund will be provided.</li>
                                    <div className="space20"></div>
                                    <li className="pd-text">No Refund would be given in a case where follow-ups are taken by the team of Dm2Legal regarding the relevant documentation and information required to complete the service but, there is no response at the end of the customer.</li>
                                    <div className="space20"></div>
                                    <li className="pd-text">If the request for a refund has been raised after the procurement of a service has been completed and the same is mentioned and intimated via email or through any form of communication asserting that the work has been completed, then, such refund request shall be considered invalid and no refund will be provided.</li>
                                </ol>

                                <div className="space10"></div>
                                <ul>
                                    <li className="pd-text"><i className="fa fa-circle icone"></i> If the request for the refund has been accepted by Dm2Legal, the same shall be processed and notified to you via email. This process of refund could take a minimum of 7 (seven) business days from the date of raising the refund request to process and shall be credited to your bank account accordingly. We at Dm2Legal administer the refund process with diligence and ensure that the money spent by you is returned to you at the quickest.</li>


                                </ul>




                            </div>

                        </div>

                    </div>
                </div>


                <div className="space50"></div>




               
            </div>






         
<WhatsAppScrollButton/>
       
       <Footer />

<CircularScrollProgress/>


        </>
    );
}

export default RefundPolicy;